import {
  VOUCHERS_PENDING,
  VOUCHERS_FAILED,
  VOUCHERS_DOWNLOADED,
  VOUCHERS_RESET,
  VOUCHER_SENDING,
  VOUCHER_DOWNLOADED,
  VOUCHER_REMOVED,
} from './types';
import VouchersApiService from '../../services/api/VouchersApiService';
import { handleError } from '../infos/actions';

export const vouchersResetAction = () => ({
  type: VOUCHERS_RESET,
});

export const voucherSendingAction = () => ({
  type: VOUCHER_SENDING,
});

export const voucherDownloadedAction = (voucher) => ({
  type: VOUCHER_DOWNLOADED,
  payload: voucher,
});

export const voucherRemovedAction = (voucher) => ({
  type: VOUCHER_REMOVED,
  payload: voucher,
});

export const vouchersDownloadedAction = (vouchers) => ({
  type: VOUCHERS_DOWNLOADED,
  payload: vouchers,
});

export const vouchersFailedAction = (error) => ({
  type: VOUCHERS_FAILED,
  payload: error,
});

export const vouchersPendingAction = () => ({
  type: VOUCHERS_PENDING,
});

export function resetVouchers() {
  return (dispatch) => {
    dispatch(vouchersResetAction());
  };
}

export function getVouchers(authUserToken, role) {
  return (dispatch) => {
    dispatch(vouchersPendingAction());
    return VouchersApiService
      .getVouchers(authUserToken, role)
      .then((data) => {
        dispatch(vouchersDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(vouchersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function postVoucher(authUserToken, datas) {
  return (dispatch) => {
    dispatch(voucherSendingAction());
    return VouchersApiService
      .postVoucher(authUserToken, datas)
      .then((data) => {
        dispatch(vouchersDownloadedAction(data));
        return data;
      })
      .catch((error) => {
        dispatch(vouchersDownloadedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function putVoucher(authUserToken, voucherId, voucher) {
  return (dispatch) => {
    dispatch(voucherSendingAction());
    return VouchersApiService
      .putVoucher(authUserToken, voucherId, voucher)
      .then((data) => {
        dispatch(voucherDownloadedAction(data));
        return data;
      })
      .catch((error) => {
        dispatch(vouchersDownloadedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function deleteVoucher(authUserToken, voucherId, voucher) {
  return (dispatch) => {
    dispatch(voucherSendingAction());
    return VouchersApiService
      .deleteVoucher(authUserToken, voucherId)
      .then(() => {
        dispatch(voucherRemovedAction(voucher));
        return null;
      })
      .catch((error) => {
        dispatch(vouchersDownloadedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/vouchers/actions.js